/**
 * check if current month is same as terminate month
 * @param {string} coverageStartDate as "MM/DD/YYYY"
 * @param {string} coverageEndDate as "MM/DD/YYYY"
 * @returns boolean 
 */

export const isSameMonthAndYear = (inputStartDate: string, inputEnDate: string): boolean => {
    const currentDate = new Date();
    let startDate = new Date(inputStartDate);
    startDate = currentDate > startDate ? currentDate : startDate;
    const endDate = new Date(inputEnDate);

    return (
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear()
    );
};